import { REPORT_METRIC_ACCENTS } from 'src/components/actionCards/actionCardColors';
import { STAGE_ICONS } from 'src/constants/stageIcons';

/**
 * Report KPI accents are chosen by what a metric MEANS, not by its position in a grid,
 * so "Leads" is the same blue on every report page (see REPORT_METRIC_ACCENTS).
 */

// KPI key (as used in the page configs) → metric meaning.
const KEY_MEANING = {
    totalLeads: 'leads',
    totalEnquiries: 'leads',
    leads: 'leads',
    consultationsBooked: 'booked',
    bookedAppointments: 'booked',
    appointmentsBooked: 'booked',
    attended: 'attended',
    consultationsAttended: 'attended',
    attendedConsultations: 'attended',
    treatmentStarted: 'started',
    startedTreatments: 'started',
    treatments: 'started',
    totalRevenue: 'started',
    totalTreatments: 'started',
    lostLeads: 'lost',
    notInterested: 'lost',
    spend: 'spend',
    totalSpend: 'spend',
};

// Legacy colour names → meaning. Red is deliberately NOT an accent (red = overdue/late
// only), so a 'red' card gets the grey "lost" accent.
const COLOR_MEANING = {
    blue: 'leads',
    purple: 'booked',
    yellow: 'attended',
    green: 'started',
    red: 'lost',
    cyan: 'spend',
};

export const accentForKpi = (key, color) => {
    const meaning = KEY_MEANING[key] || COLOR_MEANING[color] || 'leads';
    return REPORT_METRIC_ACCENTS[meaning];
};

export const accentForColor = (color) => REPORT_METRIC_ACCENTS[COLOR_MEANING[color] || 'leads'];

// KPI keys that represent a pipeline STAGE use the shared stage icon set (STAGE_ICONS).
const KEY_STAGE_ICON = {
    totalLeads: STAGE_ICONS.NEW,
    totalEnquiries: STAGE_ICONS.NEW,
    leads: STAGE_ICONS.NEW,
    consultationsBooked: STAGE_ICONS.BOOKED,
    bookedAppointments: STAGE_ICONS.BOOKED,
    appointmentsBooked: STAGE_ICONS.BOOKED,
    attended: STAGE_ICONS.ATTENDED,
    consultationsAttended: STAGE_ICONS.ATTENDED,
    attendedConsultations: STAGE_ICONS.ATTENDED,
    treatmentStarted: STAGE_ICONS.STARTED,
    startedTreatments: STAGE_ICONS.STARTED,
};

export const stageIconForKpi = (key) => KEY_STAGE_ICON[key];
